import { render, staticRenderFns } from "./Mini_Material.vue?vue&type=template&id=85ec731a&scoped=true&"
import script from "./Mini_Material.vue?vue&type=script&lang=js&"
export * from "./Mini_Material.vue?vue&type=script&lang=js&"
import style0 from "./Mini_Material.vue?vue&type=style&index=0&id=85ec731a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ec731a",
  null
  
)

export default component.exports